import type React from 'react';
import {
  Users,
  MessageCircle,
  User,
  MapPin,
} from 'react-feather';
import { formatTimeRange } from '../../../utils/formatters';
import { getDisplayTimezone, INTERNAL_TIMEZONE, formatTimeInTimezone } from '../../../utils/timezone';

/**
 * Format session date/time for display with timezone + secondary ET if coach is outside ET.
 */
export function formatSessionDateTime(start: string, end: string): string {
  const startDate = new Date(start);
  const tz = getDisplayTimezone();

  const dateStr = startDate.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: tz,
  });

  const timeRange = formatTimeRange(start, end);

  // Show secondary ET if coach's timezone differs from ET
  if (tz !== INTERNAL_TIMEZONE) {
    const etTime = formatTimeInTimezone(start, INTERNAL_TIMEZONE);
    return `${dateStr} · ${timeRange} (${etTime})`;
  }

  return `${dateStr} · ${timeRange}`;
}

/** Huddle type badge labels and colors */
export const HUDDLE_TYPE_BADGE: Record<string, { label: string; color: string }> = {
  intro: { label: 'INTRO', color: 'blue' },
  midpoint_checkin: { label: 'MIDPOINT', color: 'blue' },
  general: { label: 'CHECK IN', color: 'blue' },
};

/** Icon map for cohort event types */
export const cohortEventIcons: Record<string, React.ComponentType<{ size: number }>> = {
  coach_immersion: Users,
  participant_orientation: Users,
  coach_huddle: MessageCircle,
  cohort_wrap_up: User,
  in_person_booster: MapPin,
};

/** Format file size for display */
export function formatFileSize(bytes: number | null): string {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
